<footer class="new_footer_area bg_color">
    <div class="new_footer_top">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-6">
                    <div class="f_widget company_widget wow fadeInLeft" data-wow-delay="0.2s"
                        style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInLeft;">
                        <h3 class="f-title f_600 t_color f_size_18 text-center mb-1"><img src="/assets/img/logo/4.png"
                                alt="Logo" id="logo" class="img-fluid"></h3>
                        <p class="mb-1"><i class="fa-solid fa-location-dot"></i>16 X, Karkardooma Institutional Area,
                            Near Telephone Exchange, Delhi-110092</p>
                        <p class=" mb-1"><i class="fa-regular fa-envelope"></i> ideal_institute2@rediffmail.com</p>
                        <p class=" mb-1"><i class="fa-regular fa-envelope"></i> info@idealinstitute.edu.in</p>
                        <p class=" mb-1"><i class="fa-solid fa-phone"></i> +91 9289500488, +91 9289500788</p>
                        <p class=" mb-1"><i class="fa-solid fa-phone"></i> +91 9717594526</p>
                        <div class="f_social_icon mt-3">
                            <a href="https://www.facebook.com/idealinstitute.official" target="_blank" class="facebook"
                                title="Facebook"><i class="fa-brands fa-facebook-f"></i></a>
                            <a href="https://www.instagram.com/idealinstitute.official" target="_blank"
                                class="instagram" title="Instagram"><i class="fa-brands fa-instagram"></i></a>
                            <a href="https://x.com/iimtkarkardooma" target="_blank" class="twitter"
                                title="X (Twitter)"><i class="fa-brands fa-x-twitter"></i></a>                            
                            <a href="https://www.linkedin.com/company/idealinstituteofficial" target="_blank"
                                class="linkedin" title="LinkedIn"><i class="fa-brands fa-linkedin-in"></i></a>
                            <a href="https://www.youtube.com/@idealinstitute.official" target="_blank" class="youtube"
                                title="YouTube"><i class="fa-brands fa-youtube"></i></a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="f_widget about-widget pl_70 wow fadeInLeft" data-wow-delay="0.4s"
                        style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInLeft;">
                        <h3 class="f-title f_600 t_color f_size_18">Support</h3>
                        <ul class="list-unstyled f_list">
                            <li><a routerLink="/fee-policy">Online Fee Policies</a></li>
                            <li><a routerLink="/policy-document">Policy Documents</a></li>
                            <li><a routerLink="/mandatory-disclosure/academic-audit-2025-26">Mandatory Disclosure</a>
                            </li>
                            <li><a href="https://www.aicte.gov.in/schemes/students-development-schemes"
                                    target="_blank">AICTE Scholarships</a></li>
                            <!-- <li><a href="" target="_blank">Site Map</a></li> -->
                            <li><a routerLink="/get-direction" target="_blank">Get Direction</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="f_widget about-widget pl_70 wow fadeInLeft" data-wow-delay="0.6s"
                        style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInLeft;">
                        <h3 class="f-title f_600 t_color f_size_18">Quick Links</h3>
                        <ul class="list-unstyled f_list">
                            <!-- <li><a routerLink="/">Home</a></li> -->
                            <li><a routerLink="/gallery">Photo Gallery</a></li>
                            <!-- <li><a routerLink="/video-gallery">Video Gallery</a></li> -->
                            <li><a href="https://drive.google.com/file/d/1-pEUdcO2hmMAIGjU3tygbDZe2E-Y7glS/view?usp=sharing"
                                    target="_blank">News Letter</a></li>
                            <li><a routerLink="/alumni">Alumni</a></li>
                            <li><a routerLink="/forms/feedback">Feedback</a></li>

                            <li><a routerLink="/download">Downloads</a></li>
                            <!--<li><a href="https://cdnbbsr.s3waas.gov.in/s3ea119a40c1592979f51819b0bd38d39d/uploads/2026/01/UG.pdf"
                                    target="_blank">IPU ADMISSION BROCHURE 26-27</a></li>-->
                            <!-- <li><a href="http://www.ipu.ac.in/" target="_blank">GGSIPU</a></li> -->
                            <!-- <li><a href="https://odp.page.link/app" target="_blank">Pay Fee Online</a></li> -->
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="f_widget about-widget pl_70 wow fadeInLeft" data-wow-delay="0.6s"
                        style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInLeft;">
                        <h3 class="f-title f_600 t_color f_size_18">Legal</h3>
                        <ul class="list-unstyled f_list">
                            <li><a routerLink="/legal/terms-condition">Term and Condition</a></li>
                            <!-- <li><a routerLink="/">Licence Agreement</a></li> -->
                            <li><a routerLink="/legal/privacy-policy">Privacy Policy</a></li>
                            <li><a routerLink="/legal/refund-policy">Refund / Cancellation Policy</a></li>
                            <!-- <li><a routerLink="/">Cookies Policy</a></li> -->
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="footer_bottom">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-12 col-sm-12">
                    <p class="mt-3 mt-md-0"><a href="https://okiedokiepay.com/" target="_blank">Crafted with ❤️ by Okie
                            Dokie </a>
                        <br>
                        <a href="https://okiedokiepay.com/" target="_blank">Haryana's No. 1 Campus Automation
                            Partner</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</footer>